import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ErrorResponse.module.scss';

type Props = {
    error: string;
    testAttr: string;
};

const ErrorResponse = ({ error, testAttr }: Props): JSX.Element => {
    const { t: txt } = useTranslation();
    return (
        <div className={styles.errorMessage} {...{ [`data-${testAttr}`]: true }}>
            {txt(error)}
        </div>
    );
};

export default ErrorResponse;
